import { render, staticRenderFns } from "./ToeicSpeakingTimeManagerComponent.vue?vue&type=template&id=21d6b2de&scoped=true&"
import script from "./ToeicSpeakingTimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./ToeicSpeakingTimeManagerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6b2de",
  null
  
)

export default component.exports